import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { getUuid } from '@sibe/utilities/common';
import {
  HsGraphicObject,
  HsMatrix4,
  HsQuaternion,
  HsVector3,
  hsGenerateCubeGeometryData,
  hsMakeGeometry,
  type HsHypersceneViewer,
  type HsRegularGeometry,
} from '@sibe/hyperscene';
import { DemoViewerPage } from '../../classes/demo-viewer-page.class';
import { makeLitMaterial } from '../../functions/make-lit-material.function';

const ROTATION: HsMatrix4 = HsMatrix4.compose(
  [0, 0, 0],
  HsQuaternion.makeFromAxisAndAngle(new HsVector3(1, 0.5, 0.25).normalize().values, 0.01).values,
  [1, 1, 1]
);

/** A rotating cube built from non-indexed geometry. */
@Component({
  selector: 'regular-geometric-objects',
  templateUrl: './standard-geometric-objects.component.html',
  styleUrls: ['./standard-geometric-objects.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StandardGeometricObjects extends DemoViewerPage {
  private cube: HsGraphicObject | null = null;

  protected initScene(viewer: HsHypersceneViewer): void {
    const geometry: HsRegularGeometry | null = hsMakeGeometry(viewer.surface.graphics, hsGenerateCubeGeometryData());
    if (geometry === null) {
      return;
    }
    this.cube = new HsGraphicObject(getUuid(), 'cube', geometry, makeLitMaterial(viewer.gl, 1, 0.5, 0.25));
    this.cube.updateBoundingSphere();
    viewer.add(this.cube);
    viewer.camera.worldMatrix.setPosition([0, 0, 5]);
  }

  protected override animate(): boolean {
    this.cube?.worldMatrix.multiply(ROTATION);
    return this.cube !== null;
  }
}
